<span class="checkbox-inline">
	<label class="container">
		<ng-content></ng-content>
		<span class="checkmark">
			<img src="/assets/icon/checkmark.svg" />
		</span>
	</label>
</span>
